var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconTree48Filled = function SvgIconTree48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.26 17.65a5.29 5.29 0 0 0 5 3.75h.8a5.31 5.31 0 0 0 5.3-5.3v-.8a5.3 5.3 0 0 0-5.3-5.3h-.8a5.3 5.3 0 0 0-5.19 4.25h-8.78A5.31 5.31 0 0 0 14.1 10h-.8A5.3 5.3 0 0 0 8 15.3v.8a5.31 5.31 0 0 0 5.3 5.3h.8a5.29 5.29 0 0 0 5-3.75h2.86v10.2a5.31 5.31 0 0 0 5.3 5.3h.81a5.3 5.3 0 0 0 5.19 4.25h.8a5.31 5.31 0 0 0 5.3-5.3v-.8a5.3 5.3 0 0 0-5.3-5.3h-.8a5.28 5.28 0 0 0-5 3.75h-1a1.9 1.9 0 0 1-1.9-1.9v-10.2h2.9Z",
    fill: "current"
  })));
};
export default SvgIconTree48Filled;